module.exports = "/static/media/calls.a0ca5c79.svg";